export default __webpack_public_path__ + "static/media/event.a6ccb780.png";